require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./classements-acadmiques-internationaux-2-0-4-3.json") })
        }
      }, "path---classements-acadmiques-internationaux-2-0-4-3");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---classements-acadmiques-internationaux-2-0-4-3!./.cache/json/classements-acadmiques-internationaux-2-0-4-3.json
// module id = 371
// module chunks = 231608221292675